import { collection, doc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../services/firebase';

// بيانات حقيقية لأولياء الأمور
const parentsSeedData = [
  {
    id: 'parent_001',
    name: 'أحمد محمد العلي',
    email: 'ahmed.m.ali@gmail.com',
    phone: '+966501234567',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_002',
    name: 'فاطمة أحمد السالم',
    email: 'fatima.salem@gmail.com',
    phone: '+966502345678',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_003',
    name: 'محمد عبدالله الأحمد',
    email: 'mohammad.ahmad@gmail.com',
    phone: '+966503456789',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_004',
    name: 'سارة علي المطيري',
    email: 'sarah.mutairi@gmail.com',
    phone: '+966504567890',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_005',
    name: 'خالد سعد العتيبي',
    email: 'khaled.otaibi@gmail.com',
    phone: '+966505678901',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_006',
    name: 'منى حسن الزهراني',
    email: 'mona.zahrani@gmail.com',
    phone: '+966506789012',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_007',
    name: 'عبدالعزيز راشد القحطاني',
    email: 'abdul.qahtani@gmail.com',
    phone: '+966507890123',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_008',
    name: 'نورا عبدالرحمن الحربي',
    email: 'nora.harbi@gmail.com',
    phone: '+966508901234',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_009',
    name: 'ماجد فهد الدوسري',
    email: 'majed.dosari@gmail.com',
    phone: '+966509012345',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'parent_010',
    name: 'ريم إبراهيم الشمري',
    email: 'reem.shamari@gmail.com',
    phone: '+966510123456',
    role: 'parent',
    isActive: true,
    children: [],
    createdAt: new Date(),
    updatedAt: new Date(),
  },
];

// بيانات حقيقية للطلاب
const studentsSeedData = [
  {
    id: 'student_001',
    name: 'عبدالرحمن أحمد العلي',
    email: 'abdulrahman.ali@student.com',
    phone: '+966511234567',
    role: 'student',
    grade: 'الصف العاشر',
    isActive: true,
    parentId: 'parent_001',
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'student_002',
    name: 'نور فاطمة السالم',
    email: 'noor.salem@student.com',
    phone: '+966512345678',
    role: 'student',
    grade: 'الصف التاسع',
    isActive: true,
    parentId: 'parent_002',
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'student_003',
    name: 'عمر محمد الأحمد',
    email: 'omar.ahmad@student.com',
    phone: '+966513456789',
    role: 'student',
    grade: 'الصف الحادي عشر',
    isActive: true,
    parentId: 'parent_003',
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'student_004',
    name: 'لينا سارة المطيري',
    email: 'lina.mutairi@student.com',
    phone: '+966514567890',
    role: 'student',
    grade: 'الصف الثامن',
    isActive: true,
    parentId: 'parent_004',
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'student_005',
    name: 'يوسف خالد العتيبي',
    email: 'yousef.otaibi@student.com',
    phone: '+966515678901',
    role: 'student',
    grade: 'الصف الثاني عشر',
    isActive: true,
    parentId: 'parent_005',
    createdAt: new Date(),
    updatedAt: new Date(),
  },
];

// بيانات حقيقية للمدرسين
const teachersSeedData = [
  {
    id: 'teacher_001',
    name: 'د. عمر الحسن المالكي',
    email: 'omar.maliki@teacher.com',
    phone: '+966521234567',
    role: 'teacher',
    isActive: true,
    teacherProfile: {
      subjects: ['الرياضيات', 'الفيزياء'],
      bio: 'دكتور في الرياضيات التطبيقية، خبرة 15 سنة في التدريس',
      pricePerHour: 150,
      currency: 'EGP',
    },
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'teacher_002',
    name: 'أ. فاطمة الزهراء النجار',
    email: 'fatima.najjar@teacher.com',
    phone: '+966522345678',
    role: 'teacher',
    isActive: true,
    teacherProfile: {
      subjects: ['اللغة العربية', 'الأدب'],
      bio: 'أستاذة اللغة العربية وآدابها، ماجستير في الأدب الحديث',
      pricePerHour: 120,
      currency: 'EGP',
    },
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: 'teacher_003',
    name: 'م. أحمد عبدالله الشهري',
    email: 'ahmed.shahri@teacher.com',
    phone: '+966523456789',
    role: 'teacher',
    isActive: true,
    teacherProfile: {
      subjects: ['الكيمياء', 'الأحياء'],
      bio: 'مهندس كيميائي، متخصص في العلوم التطبيقية',
      pricePerHour: 140,
      currency: 'EGP',
    },
    createdAt: new Date(),
    updatedAt: new Date(),
  },
];

export async function seedDatabase() {
  try {
    console.log('بدء إدخال البيانات التجريبية...');

    // إضافة أولياء الأمور إلى مجموعة users
    for (const parent of parentsSeedData) {
      await setDoc(doc(db, 'users', parent.id), {
        ...parent,
        createdAt: Timestamp.fromDate(parent.createdAt),
        updatedAt: Timestamp.fromDate(parent.updatedAt),
      });

      // إضافة سجل في مجموعة parents
      await setDoc(doc(db, 'parents', parent.id), {
        children: parent.children,
        createdAt: Timestamp.fromDate(parent.createdAt),
        updatedAt: Timestamp.fromDate(parent.updatedAt),
      });

      console.log(`تم إضافة ولي الأمر: ${parent.name}`);
    }

    // إضافة الطلاب إلى مجموعة users
    for (const student of studentsSeedData) {
      await setDoc(doc(db, 'users', student.id), {
        name: student.name,
        email: student.email,
        phone: student.phone,
        role: student.role,
        isActive: student.isActive,
        createdAt: Timestamp.fromDate(student.createdAt),
        updatedAt: Timestamp.fromDate(student.updatedAt),
      });

      // إضافة سجل في مجموعة students
      await setDoc(doc(db, 'students', student.id), {
        grade: student.grade,
        parentId: student.parentId,
        createdAt: Timestamp.fromDate(student.createdAt),
        updatedAt: Timestamp.fromDate(student.updatedAt),
      });

      // ربط الطالب بولي الأمر في مجموعة parents
      if (student.parentId) {
        const parentDoc = await doc(db, 'parents', student.parentId);
        await setDoc(
          parentDoc,
          {
            children: [student.id],
            createdAt: Timestamp.now(),
            updatedAt: Timestamp.now(),
          },
          { merge: true }
        );
      }

      console.log(`تم إضافة الطالب: ${student.name}`);
    }

    // إضافة المدرسين إلى مجموعة users
    for (const teacher of teachersSeedData) {
      await setDoc(doc(db, 'users', teacher.id), {
        ...teacher,
        createdAt: Timestamp.fromDate(teacher.createdAt),
        updatedAt: Timestamp.fromDate(teacher.updatedAt),
      });

      console.log(`تم إضافة المدرس: ${teacher.name}`);
    }

    console.log('✅ تم إدخال جميع البيانات التجريبية بنجاح!');
  } catch (error) {
    console.error('❌ خطأ في إدخال البيانات:', error);
  }
}

// دالة لمسح البيانات التجريبية
export async function clearSeedData() {
  try {
    console.log('بدء مسح البيانات التجريبية...');

    const allIds = [
      ...parentsSeedData.map(p => p.id),
      ...studentsSeedData.map(s => s.id),
      ...teachersSeedData.map(t => t.id),
    ];

    for (const id of allIds) {
      // حذف من users
      await setDoc(doc(db, 'users', id), {}, { merge: false });

      // حذف من parents/students حسب النوع
      if (id.startsWith('parent')) {
        await setDoc(doc(db, 'parents', id), {}, { merge: false });
      } else if (id.startsWith('student')) {
        await setDoc(doc(db, 'students', id), {}, { merge: false });
      }
    }

    console.log('✅ تم مسح البيانات التجريبية بنجاح!');
  } catch (error) {
    console.error('❌ خطأ في مسح البيانات:', error);
  }
}
